<template>

  <!-- Page Wrapper -->
  <!-- Page Content -->
  <div class="content container-fluid">

    <!-- /Search Filter -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <table class="table table-striped custom-table mb-0">
            <thead>
              <tr>
                <th style="width:10%;"></th>
                <th>Destination</th>
                <th>Message</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="loading">
                <tr>
                  <td colspan="3">
                    <Skeleton :count="1" />
                  </td>
                </tr>
              </template>
              <template v-if="rows.length">
                <tr v-for="(row, index) in rows" :key="index">
                  <td>{{ row.number }}.</td>
                  <td class="text-wrap">
                    <a target="_blank" :href="'https://api.whatsapp.com/send?phone=' + row.message_number">{{
                row.message_number
              }}</a>
                  </td>
                  <td class="text-wrap">{{ row.message }}</td>
                </tr>
              </template>
              <template v-if="loading">
                <tr>
                  <td colspan="3">
                    <Skeleton :count="1" />
                  </td>
                </tr>
              </template>
              <template v-else-if="rows.length < 1 && !loading">
                <tr>
                  <td colspan="5" class="text-center">-empty-</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row" v-if="rows.length>serverParams.perPage">
      <div class="col-sm-12 col-md-6">
        <span class="footer__row-count__label">Displaying</span>
        <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
          v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
          <option value="10">10 / page</option>
          <option value="20">20 / page</option>
          <option value="30">30 / page</option>
          <option value="40">40 / page</option>
          <option value="50">50 / page</option>
        </select>
        <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
      </div>
      <div class="col-sm-12 col-md-6 text-right">
        <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
          :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
          <span class="chevron left"></span>
          <span>Prev</span>
        </a>
        page
        <input style="width:100px;" min="1" type="number" v-model="currentPage"
          @keyup.enter="onPageChange(parseInt(currentPage))" class />
        of {{ Math.ceil(totalRecords / serverParams.perPage) }}
        <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
          class="footer__navigation__page-btn" :class="'btn ' + {
                disabled:
                  parseInt(currentPage) + 1 >
                  Math.ceil(totalRecords / serverParams.perPage)
              }">
          <span>Next</span>
          <span class="chevron right"></span>
        </a>
      </div>
    </div>
  </div>


</template>

<script>
import {
  getWhatsappNumberFromJid
} from "@/utils/helper";


import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton,
  },
  data() {
    return {
      param_broadcast_id: '',
      selectedTable: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          broadcast_id: "",
          message: "",
          message_number: ""
        },
        page: 1,
        perPage: 10 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    broadcastParamSt() {
      return this.$store.state.omniwa.broadcastParamSt;
    },
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },

  created() {
    // this.asyncFind("");

    this.loadItems();
    this.currentPage = this.serverParams.page;

    this.$root.$on("searchDataImport", async () => {
      this.searchDataImport()
      // console.log("searchDataImport load");
      // console.log(this.$store.getters.getRoomById(roomArr.room_id));
      // this.roomDetail = this.$store.getters.getRoomById(roomArr.room_id);
    });
  },
  methods: {
    limitText(count) {
      return `and ${count} other`;
    },
    clearAll() {
      this.selectedContact = [];
    },
    getWhatsappNumberFromJid(value) {
      return getWhatsappNumberFromJid(value);
    },


    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchDataImport() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.serverParams.columnFilters.broadcast_id = this.broadcastParamSt.broadcast_id;
      if (
        typeof this.$route.query.broadcast_id != "undefined" &&
        this.$route.query.broadcast_id != ""
      ) {
        this.serverParams.columnFilters.broadcast_id = this.$route.query.broadcast_id;
        this.param_broadcast_id = this.serverParams.columnFilters.broadcast_id
        this.serverParams.columnFilters.period = "";
      }

      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("messageReport/listBroadcastImport", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "listBroadcastImport"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/componentsImport/previewImport.vue